import gql from 'graphql-tag'

export const SIGNUP = gql`
  mutation SignUp(
    $heroType: HeroType!
    $name: String!
    $email: String!
    $zipcode: String
    $tel: String!
    $lineId: String
    $plateLicense: String
    $province: String
    $purpose: String
    $postalAddress: String
    $password: String!
  ) {
    signup: heroSignup(
      heroType: $heroType
      name: $name
      email: $email
      password: $password
      tel: $tel
      lineId: $lineId
      zipcode: $zipcode
      plateLicense: $plateLicense
      purpose: $purpose
      province: $province
      postalAddress: $postalAddress
    ) {
      user {
        id
      }
      token
    }
  }
`

export const LOGIN_WITH_EMAIL = gql`
  mutation LoginWithEmail($email: String!, $password: String!) {
    login: heroLogin(email: $email, password: $password) {
      user {
        id
        name
        email
        status
        heroType
      }
      token
    }
  }
`

export const LOGIN_WITH_TEL = gql`
  mutation LoginWithTel($tel: String!, $password: String!) {
    login: heroLoginWithTel(tel: $tel, password: $password) {
      user {
        id
        name
        tel
        status
        heroType
      }
      token
    }
  }
`

export const LOGIN_WITH_CIRCULAR_ID = gql`
  mutation LoginWithCircularId($binId: String!, $password: String!) {
    login: heroLoginWithCircularId(binId: $binId, password: $password) {
      user {
        id
        avatar {
          url
        }
        status
      }
      token
    }
  }
`

export const REQUEST_RESET_PASSWORD = gql`
  mutation RequestResetPassword($email: String!) {
    requestResetPassword(email: $email)
  }
`

export const RESET_PASSWORD = gql`
  mutation ResetPassword($token: String!, $newPassword: String!) {
    resetPassword(token: $token, newPassword: $newPassword)
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/Auth.js